import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class MappingRenewal extends RestApiModel {
  static getResourceEndpoint() {
    return '/mapping-renewals';
  }

  static deleteMultiple(ids) {
    return api.post(`${this.getResourceEndpoint()}/delete-multiple`, { ids });
  }
  
}

export default MappingRenewal;
